import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../../";

export const selectChat = (state: RootState) => state.chat;

export const selectChatMessages = createSelector([selectChat], (chat) => chat.messages);
